import apiClient from "./apiClient";

const API_URL = `/attendance`; // Use relative path since apiClient has baseURL

export const applyLeave = async (data) => {
  // Remove organizationId from data if it exists (apiClient will add it via interceptor)
  const { organizationId, ...leaveData } = data;
  
  // apiClient will automatically add organizationId via interceptor
  // For POST requests, organizationId is added to request body by default
  const response = await apiClient.post(`${API_URL}/applyLeave`, leaveData);
  return response.data;
};

export const getLeavesByUserId = async (userId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  // This endpoint accepts userId and the backend should look up staff/doctor internally
  const response = await apiClient.get(`${API_URL}/user/${userId}`);
  return response.data;
};

// Alternative: Get leaves by staff ID directly
export const getLeavesByStaffId = async (staffId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/staff/${staffId}`);
  return response.data;
};

// Alternative: Get leaves by doctor ID directly
export const getLeavesByDoctorId = async (doctorId) => {
  // apiClient will automatically add organizationId as query param via interceptor
  const response = await apiClient.get(`${API_URL}/doctor/${doctorId}`);
  return response.data;
};

// export const getLeavesByUserId = async (userId, roleName) => {
//   const endpoint = roleName === 'doctor' 
//     ? `/doctor/${userId}`
//     : `/staff/${userId}`;
//   const response = await axios.get(`${API_URL}${endpoint}`);
//   return response.data;
// };

// Add more leave related APIs if needed later
